<script lang="ts">
  import { type Size, SIZE_MAP } from './icon';
  interface Props {
    size?: Size;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [key: string]: any;
  }
  let { size = $bindable('md'), ...rest }: Props = $props();
  let computedSize = $derived(SIZE_MAP[size] as Size);
</script>

<svg
  xmlns="http://www.w3.org/2000/svg"
  width={computedSize}
  height={computedSize}
  viewBox="0 0 24 24"
  {...rest}>
  <g>
    <path
      d="M10.333 19.667a1.667 1.667 0 1 0 3.333 0 1.667 1.667 0 0 0-3.333 0Zm0-7.667a1.667 1.667 0 1 0 3.334 0 1.667 1.667 0 0 0-3.334 0Zm0-7.667a1.667 1.667 0 1 0 3.333 0 1.667 1.667 0 0 0-3.333 0Z"
      fill="currentColor" />
  </g>
</svg>
